<template>
  <div class="row">
      <div class="col-12 grid-margin">
        <div class="card no-border card-2">
          <div class="card-body">
            <h3 class="card-title mb-4">
              Shopify Orders List
              <record-modes />
            </h3>
            <p>Use different search options to suit your needs</p>
              <orders-filter />
              <orders-with-items></orders-with-items>
              <tag-selector-sidebar />
              <customer-draft-slide-out />
              <order-list-bottom-widget />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  // const OrdersTable = () => import(/* webpackChunkName: "orders.orders-table" */ './orders-table');
  const OrdersWithItems = () => import(/* webpackChunkName: "orders.orders-with-items" */ './orders-with-items/orders-with-items');
  const OrdersFilter = () => import(/* webpackChunkName: "orders.orders-filter" */ './orders-filter');
  const TagSelectorSidebar = () => import(/* webpackChunkName: "orders.tag-selector-sidebar" */ './tag-selector-sidebar')
const CustomerDraftSlideOut = () => import(/* webpackChunkName: "orders.customer-draft-slideout" */ './customer-drafts/customer-draft-slideout')
const RecordModes = () => import(/* webpackChunkName: "partials.record-modes" */ './partials/record-modes');
const OrderListBottomWidget = () => import(/* webpackChunkName: "order-list-bottom-widget" */ './list/order-list-bottom-widget')
  export default {
      components: {OrdersWithItems, OrdersFilter, TagSelectorSidebar, CustomerDraftSlideOut, RecordModes, OrderListBottomWidget},
  }
</script>

<style lang="scss" scoped>

</style>
